import { render, staticRenderFns } from "./ColorfulBars.vue?vue&type=template&id=bd3689d6"
import script from "./ColorfulBars.vue?vue&type=script&lang=js"
export * from "./ColorfulBars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd3689d6')) {
      api.createRecord('bd3689d6', component.options)
    } else {
      api.reload('bd3689d6', component.options)
    }
    module.hot.accept("./ColorfulBars.vue?vue&type=template&id=bd3689d6", function () {
      api.rerender('bd3689d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/statistics/progress-bars/Widgets/ColorfulBars.vue"
export default component.exports